import { useEffect, useState, useRef } from 'react';
import { gapi } from 'gapi-script';
import { Button, Dialog, Typography, TextField, Checkbox, LinearProgress, Box } from '@mui/material';
import { Scrollbars } from 'rc-scrollbars';
// import {default as googleicon} from '../images/apis/google.png'
import Icon from "@material-ui/core/Icon";
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import { styled } from "@mui/system";
import ClassicSearch from 'components/classicSearch';

// Стилизация заблоченного диалогового окна
const DisabledBackgroundDialog = styled(Box)({
    height:'280px', 
    width:'600px',
    borderRadius: "40px",
    position: "fixed",
    background: "#ccc",
    opacity: 0.5,
    zIndex: 1
  });

  // Полоса загрузки
  const LinearLoadingDialog = () => (
    <>
      <DisabledBackgroundDialog />
      <LinearProgress sx={{ zIndex: 2 }} />
    </>
  );

  // Стилизация заблоченного меню
  const DisabledBackgroundMenu = styled(Box)({
    width:'700px', 
    height:'700px',
    position: "fixed",
    background: "#ccc",
    opacity: 0.5,
    zIndex: 1
  });

  // Полоса загрузки
  const LinearLoadingMenu = () => (
    <>
      <DisabledBackgroundMenu />
      <LinearProgress sx={{ zIndex: 2 }} />
    </>
  );


// Создание нового документа в гугл докс
export const createGoogleDoc = async ({name = "New FulfLab Doc"}) => {
    const response = await gapi.client.docs.documents.create({
      resource: { title: name },
    });
    console.log('https://docs.google.com/document/d/' + response.result.documentId + '/export?format=pdf');
    await gapi.client.drive.permissions.create({
      fileId: response.result.documentId,
      resource: {
        role: "reader",
        type: "anyone",
      },
    });
    return response.result.documentId;
};

// Получение массива файлов из гугла
export const listFiles = async () => {
    try {
        const response = await gapi.client.drive.files.list({
            q: "mimeType='application/vnd.google-apps.document'", // Фильтруем только Google Docs
            fields: "files(id, name)",
        });
        // console.log("Документы:", response.result.files);
        return response.result.files
    } catch (error) {
        console.error("Ошибка при получении списка файлов:", JSON.stringify(error));
        return {error: "Ошибка при получении списка файлов:\n" + error}
    }
};

// Проверка токена на существование и права
const checkAccessToken = async (access_token, requiredScopes = []) => {
  try {
    const res = await fetch(`https://www.googleapis.com/oauth2/v1/tokeninfo?access_token=${access_token}`);
    
    if (!res.ok) {
      console.warn('Access token is invalid or expired');
      return false;
    }

    const data = await res.json();

    // Преобразуем scopes в Set для удобства сравнения
    const grantedScopes = new Set(data.scope.split(' '));

    // Проверка: все ли нужные scope есть
    const hasAllScopes = requiredScopes.every(scope => grantedScopes.has(scope));

    if (!hasAllScopes) {
      console.warn('Access token is missing required scopes:', requiredScopes);
      return false;
    }

    console.log('Token is valid with required scopes:', data);
    return true;
  } catch (err) {
    console.error('Error while checking access token:', err);
    return false;
  }
};

// Кнопка логина в гугл
export const GoogleLogInButton = (token, setToken) => {
  // Картинка для кнопки
    const googleSvg = (
        <Icon>
          <img alt="edit" src="google.svg" />
        </Icon>
      );

    // Функция логина
    const signIn = async () => {
      try {
        const GoogleAuth = gapi.auth2.getAuthInstance();

        await GoogleAuth.signIn({
          scope: 'https://www.googleapis.com/auth/drive https://www.googleapis.com/auth/documents',
        });

        const token = gapi.auth.getToken()?.access_token;
        const valid = await checkAccessToken(token);

        if (valid) {
          setToken(token);
        }
      } catch (err) {
        console.error('Ошибка входа:', err);
      }
    };

    return (
        <div className="googlebuton">
            <Button variant="outlined" style={!token ? {margin: '10px', height:'40px', width:'160px', backgroundColor:'white'} : {margin: '10px', height:'40px', width:'160px', backgroundColor:'white'}} onClick={signIn} startIcon={googleSvg}>
                {!token ? 'Войти' : 'Вы вошли'}
            </Button>
        </div>
    );
}


// Кнопка создания документа
export const GoogleCreateDocButton = () => {
    return (
        <div>
            <Button variant="outlined" disabled={!gapi.auth.getToken()?.access_token} style={{margin: '10px', height:'40px', width:'200px', backgroundColor:'white'}} startIcon={<TextSnippetIcon/>}>
                Новый документ
            </Button>
        </div>
    );
}

// Обёртка на создание документа для получения параметров нового документа
export function CreateDoc({setiframe, closeUp}){
    const [fname, setFName] = useState('');
    const [isloading, setIsLoading] = useState(false);
  
    const [open, setOpen] = useState(false);
    const DialoghandleClickOpen = () => {
      setOpen(true);
    };
  
    const DialoghandleClose = () => {
      setFName('');
      setIsLoading(false);
      setOpen(false);
    };
  
    const DialoghandleCreate = () => {
        if (fname){
            setIsLoading(true);
            createGoogleDoc({name:fname}).then(resp => {
                setiframe(resp); DialoghandleClose(); closeUp();
            })
        }
        // DialoghandleClose(); closeUp();
    };
  
    return(
      <div>
        <Button variant="outlined" onClick={DialoghandleClickOpen} disabled={!gapi.auth.getToken()?.access_token} style={{margin: '10px', height:'40px', width:'200px', backgroundColor:'white'}} startIcon={<TextSnippetIcon/>}>
            Новый документ
        </Button>
        <Dialog
          open={open}
          onClose={DialoghandleClose}
          PaperProps={{ sx: { borderRadius: "40px" } }}
        >
          <Box
            style={{height:'280px', width:'600px'}}
          >
            {
            isloading ? 
                <LinearLoadingDialog/> :<></>
            }
            <div style = {{position: 'relative', paddingTop: '15px'}}>
              <div style = {{alignContent: 'center', alignItems: 'center'}}>
                  <div style={{ display: 'flex', flexDirection:'column', alignItems: 'center' }}>
                      <Typography variant="body1" sx={{fontWeight: '300', fontSize: '25px', display: 'row', marginTop:'20px'}}>Создать новый документ</Typography>
                      <TextField variant="filled" label="Имя" onChange={(e) => {setFName(e.target.value);}} sx={{position: 'relative', fontWeight: '400', backgroundColor:'#e0e0e0', marginTop:'30px', width:'70%', borderRadius:'10px', "& .MuiFilledInput-root":{backgroundColor: "#e0e0e0", borderRadius:'7px'}}} InputProps={{disableUnderline: true}}></TextField>
                  </div>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop:'30px'}}>
                <Button variant="contained" onClick={DialoghandleClose} sx={{textTransform: 'none', margin: '10px', fontWeight: 'bold', backgroundColor:'#078376'}} >Отмена</Button>
                <Button variant="contained" onClick={DialoghandleCreate} sx={{textTransform: 'none', margin: '10px', fontWeight: 'bold', backgroundColor:'#078376'}}>Создать</Button>
              </div>
            </div>
          </Box>
        </Dialog>
      </div>
    )
}


// Компонент для отображения документов из google
export function ListOfDocs({setiframe}){
  // переменная под токен
  const [token, setToken] = useState(null);
    // Фильтр для грядущего правочника
    const [filter, setFilterName] = useState(null);
    
    // Состояние загрузки
    const [isloading, setIsLoading] = useState(false);
    // состояние окна с документами
    const [open, setOpen] = useState(true);
    // Обработчик открытия окна
    const DialoghandleClickOpen = () => {
      setOpen(true);
    };
    // Обработчик закрытия окна
    const DialoghandleClose = () => {
      setOpen(false);
    };
    // Массив полученных документов
    const [listDocs, setListDocs] = useState(null);

    // Хук на получение документов после проверки токена
    useEffect(() => {
      const token = gapi.auth.getToken()?.access_token;
      console.log("token", token)
      if (token) {
        checkAccessToken(token, [
          'https://www.googleapis.com/auth/drive',
          'https://www.googleapis.com/auth/documents',
        ]).then((isValid) => {
          if (isValid) {
            setToken(token);
            if (open)
              setIsLoading(true);
              listFiles().then((val)=>{if (!val.error) setListDocs(val); console.log('documents>>>>>>>>>>>>>>>>', val); setIsLoading(false);})
          } else {
            console.warn("Токен есть, но у него не хватает прав");
          }
        });
      }
    }, [open, setiframe]);
    
    // Выбор документа для iframe
    const choseDoc = (id) => {
        console.log(filter);
        setiframe(id);
        DialoghandleClose();
    }


    const [checked, setChecked] = useState(false);

    return(
      <div
      style={{backgroundColor:'white', width:'100%', height:'100%', borderLeft:'2px solid green', borderTop:'2px solid green'}}
      >
        <div style={{display:'flex', backgroundColor:'white', width:'100%', height:'100%'}}>
            <ClassicSearch setChecked={setChecked} setFilter={setFilterName} checked={checked}/>
            <Button variant="outlined" sx={{height:'40px', display:'inline', textTransform: 'none', fontWeight: 'bold', marginLeft:'auto', marginRight:'5px', marginTop:'5px'}} onClick={DialoghandleClickOpen}>Меню</Button>
        </div>
        <Dialog
          open={open}
          onClose={DialoghandleClose}
          PaperProps={{ sx: { borderRadius: "20px", maxWidth:'1700px'} }}
        >
            <div style={{display:'block', width:'740px', height:'1000px'}}>
                <div style={{display:'inline-block', margin:'20px'}}>
                <Typography variant="body1" gutterBottom sx={{display:'block', height:'30px', align:"center", marginLeft:'12px', fontSize:'20px', fontWeight: 'bold', width:'80%'}}>Список документов:</Typography>
                    <Box style={{display:'block', width:'700px', height:'700px', maxWidth:'700px', maxHeight:'700px', border:'solid 1px green'}}>
                      <Scrollbars
                        className='mainContainer'
                        autoHeight autoHeightMax={700}
                        >
                          {isloading ? <LinearLoadingMenu/> : listDocs ? listDocs.map(((el, index) => {return <Button key={index} style={{display:'block', margin:'10px'}} variant="text" onClick={() => {choseDoc(el.id)}}>{el.name}</Button>})) : <Typography variant="body1" gutterBottom sx={{display:'block', height:'22px', align:"center", marginLeft:'12px', fontWeight: 'bold', width:'80%'}}>Авторизируйтесь для продолжения</Typography>}
                      </Scrollbars>
                    </Box>
                </div>
                <div style={{display:'flex', margin:'20px', width:'700px', height:'80px', alignItems: 'center', justifyContent: 'center',}}>
                    <CreateDoc 
                        setiframe={setiframe}
                        closeUp={DialoghandleClose}
                    />
                    <GoogleLogInButton
                    token={token}
                    setToken={setToken}
                    />
                </div>
                
            </div>
        </Dialog>
      </div>
    )
  }

